// extracted by mini-css-extract-plugin
export default {"page":"KY-z","cartModal":"LY-z","checkout":"MY-z","placeholder":"NY-z","account":"OY-z"};